export const getItemBaseToSelect = (gender = 0) => {
  const value = gender === 1 ? 'a' : 'o';

  return [{ text: `Tod${value}s`, value: '0' }];
};

export const getDefaultAccommodationOptions = () => [
  { text: 'Menor preço', value: 'cheaper' },
  { text: 'Não incluir', value: 'none' },
];
